export default __webpack_public_path__ + "static/media/stripe.5bad30aa.webp";